import type { RouteObject } from 'react-router-dom'

import { MainLayout } from '@/layouts'

export const profileRoutes: RouteObject = {
  path: 'profile',
  element: <MainLayout />,
  children: [
    {
      index: true,
      lazy: async () => {
        const module = await import('@/features/profile/pages/ProfilePage')
        return {
          element: <module.ProfilePage />
        }
      }
    }
  ]
}
